import { Heading } from "@medoma/components/Heading/Heading";
import { Text } from "@medoma/components/Text/Text";
import styles from "./cardHeading.module.scss";
import HouseIcon from "@medoma/components/icons/HouseIcon";
import VideoCameraIcon from "@medoma/components/icons/VideoCameraIcon";
import AvatarIcon from "@medoma/components/icons/AvatarIcon";
import {
  categorySchema,
  type IActivityCategory,
} from "@medoma/models/activities";
import HealthParametersIcon from "@medoma/components/icons/HealthParametersIcon";
import clsx from "clsx";
import MedicalCircleIcon from "@medoma/components/icons/MedicalCircleIcon";

type ICardHeading = {
  category: IActivityCategory;
  title: string;
  formattedTimespan: string | null;
};

export const CardHeading = ({
  category,
  title,
  formattedTimespan,
}: ICardHeading) => {
  const renderIcon = () => {
    switch (category) {
      case categorySchema.enum.HomeVisit:
        return <HouseIcon />;
      case categorySchema.enum.VideoCall:
        return <VideoCameraIcon />;
      case categorySchema.enum.ClinicVisit:
        return <MedicalCircleIcon />;
      case categorySchema.enum.PatientTask:
        return <AvatarIcon />;
      case categorySchema.enum.PatientMeasurementTask:
        return <HealthParametersIcon />;
      case categorySchema.enum.PhoneCall:
      case categorySchema.enum.AdminTask:
        return;
      default:
        throw category satisfies never;
    }
  };

  return (
    <header className={styles.cardHeading}>
      <div className={styles.iconAndTitle}>
        <span className={clsx([styles.icon, styles[`category-${category}`]])}>
          {renderIcon()}
        </span>
        <Heading level="h2" size="h3" weight="bold">
          {title}
        </Heading>
      </div>
      {formattedTimespan ? (
        <Text element="span">{formattedTimespan}</Text>
      ) : null}
    </header>
  );
};
